import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'shared-ui-control-textarea',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './control-textarea.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.id]': 'null',
  },
})
export class ControlTextareaComponent {
  readonly control = input.required<FormControl<string>>();
  readonly id = input.required<string>();
  readonly label = input.required<string>();
  readonly placeholder = input('');
  readonly rows = input(5);
  readonly optional = input(false);
  readonly errorText = input('');
  readonly invalid = input<boolean | null>(null);

  protected showInvalid(): boolean {
    const explicitInvalid = this.invalid();

    if (explicitInvalid !== null) return explicitInvalid;

    const control = this.control();

    return control.invalid && (control.touched || control.dirty);
  }

  protected textareaClass(): string {
    if (this.showInvalid()) {
      return 'border-red-400 placeholder-gray-400 focus:border-red-400 focus:ring-1 focus:ring-red-400';
    }

    return 'border-gray-300 placeholder-gray-400 focus:border-green-800 focus:ring-1 focus:ring-green-800';
  }
}
